import {useHostedZoneQuery} from './useHostedZonesQuery';

// Single-record hook for the detail page. This is the ONLY place `nameServers`
// arrives — the list query returns it as null for every row (see queries.ts).
export const useHostedZone = (id?: string, parentDomainName?: string) => {

    const {
        data: record,
        isLoading,
        isError,
        isSuccess,
        refetch,
    } = useHostedZoneQuery(id, parentDomainName);

    return {
        record,
        loading: isLoading,
        isError,
        // A resolved query that returned nothing is NOT an error — the id simply
        // does not name a zone. The two need different copy on the page.
        notFound: isSuccess && !record,
        fetchRecord: () => refetch(),
    };
};
